import React from 'react';
import { Box, Typography, Link, Divider } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#f8f9fa',
        padding: '40px 20px 20px',
        marginTop: 'auto',
        borderTop: '1px solid #e0e0e0'
      }}
    >
      {/* Main tagline */}
      <Box sx={{ textAlign: 'center', marginBottom: '30px' }}>
        <Typography 
          variant="body1" 
          sx={{ 
            color: '#555',
            fontSize: '16px',
            lineHeight: '1.5',
            maxWidth: '600px',
            margin: '0 auto'
          }}
        >
          MyBingo Social is built to spark fun, laughter, and connection inside teams and events — online or offline.
        </Typography>
      </Box>

      {/* Navigation links */}
      <Box sx={{ textAlign: 'center', marginBottom: '20px' }}>
        <Box sx={{ marginBottom: '15px' }}>
          <Typography component="span" sx={{ margin: '0 8px', color: '#999' }}>•</Typography>
          <Link 
            href="/how-it-works "
            sx={{ 
              color: '#333', 
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 500,
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            How It Works
          </Link>
          <Typography component="span" sx={{ margin: '0 8px', color: '#999' }}>•</Typography>
          <Link 
            href="/usecases" 
            sx={{ 
              color: '#333', 
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 500,
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Use Cases
          </Link>
          <Typography component="span" sx={{ margin: '0 8px', color: '#999' }}>•</Typography>
          <Link 
            href="/contact" 
            sx={{ 
              color: '#333', 
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 500,
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Contact
          </Link>
          <Typography component="span" sx={{ margin: '0 8px', color: '#999' }}>•</Typography>
        </Box>

        <Box>
          <Link 
            href="#" 
            sx={{ 
              color: '#333', 
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 500,
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Privacy Policy
          </Link>
          <Typography component="span" sx={{ margin: '0 8px', color: '#999' }}>|</Typography>
          <Link 
            href="#" 
            sx={{ 
              color: '#333', 
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 500,
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            LinkedIn
          </Link>
          <Typography component="span" sx={{ margin: '0 8px', color: '#999' }}>|</Typography>
          <Link 
            href="#" 
            sx={{ 
              color: '#333', 
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 500,
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Terms
          </Link>
        </Box>
      </Box>

      {/* Copyright or additional info can go here */}
      <Box sx={{ textAlign: 'center', marginTop: '20px' }}>
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#888',
            fontSize: '12px'
          }}
        >
          © 2025 MyBingo.social
        </Typography>
        <Typography
              variant="h6"
              sx={{
                color: "#888",
                fontWeight: 500,
              }}
            >
              🎮 Game On! Let's Create Epic Experiences Together! 🚀
            </Typography>
      </Box>
    </Box>
  );
};

export default Footer;